import {distinctUntilChanged, map, startWith} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {ConstantsService} from '../constants.service';
import {Observable, of} from 'rxjs';
import {AffiliateService} from '../affiliate.service';
import {AuthService} from '../auth.service';
import {AsyncPipe, NgClass} from '@angular/common';

@Component({
    selector: 'app-oauth-link',
    template: `<a [href]="(registerUri | async) + getState(redirectUrl | async, promotion | async)"
                  [ngClass]="{'btn': button, 'btn-outline-primary': button}">
      <ng-content></ng-content>
      @if (logo) {
        <img width='auto' height='20' src='../../assets/podio_original/ProgressPodio_SecondaryLogo.svg' alt='Podio logo'>
      }
    </a>`,
    styleUrls: ['./oauth-link.component.scss'],
    imports: [NgClass, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OauthLinkComponent implements OnInit {

    /**
     * Overwrites default redirect (see auth.service)
     */
    @Input()
    redirect: string = null;
    @Input()
    logo = true;
    @Input()
    button = true;

    registerUri: Observable<string> = null;
    redirectUrl: Observable<string> = null;
    promotion: Observable<string> = null;

    constructor(public constants: ConstantsService,
                private affiliate: AffiliateService,
                private authService: AuthService) {
    }

    ngOnInit() {
        this.registerUri = this.constants.registerUri$.pipe(map(u => u ?? '/'));

        if (this.redirect) {
            this.redirectUrl = of(this.redirect);
        } else {
            this.redirectUrl = this.authService.redirectUrl$;
        }

        this.promotion = this.affiliate.promotion.pipe(
            map(promo => promo.name ? promo.name : ''),
            startWith(''),
            distinctUntilChanged(), );
    }

    public getState(path: string, promo: string) {
        const state = '&state=' + encodeURIComponent(JSON.stringify({
                'promo': promo,
                'redirect': path
            }));
        return state;
    }
}
